import React, { useContext } from "react";
import { VisuallyHidden } from "react-aria";
import { t } from "ttag";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { FavoritesContext } from "../../favorites";
import { Clickable } from "../Clickables";
import { Svg } from "../Svg";
import { BurgerButton } from "./BurgerButton";
import { useHeaderContext } from "./HeaderContext";
import { SEARCH_SUBMENU, SearchSubmenu } from "./SearchSubmenu";

import themeStyles from "../../styles/themes-2026.module.scss";
import styles from "./MobileNav.module.scss";

export const MobileNav = () => {
    const {
        isMobileLayout,
        isOverlapping,
        isAtTop,
        mobileMenuOpen,
        setMobileMenuOpen,
        activeSubmenu,
        setActiveSubmenu,
        scrollDirection,
        favoritesUrl,
    } = useHeaderContext();
    const favs = useContext(FavoritesContext);
    const hasFavorites = favs.items.length > 0;

    const isOpen = mobileMenuOpen || activeSubmenu;

    const isHidden = scrollDirection === "DOWN" && !isAtTop && !isOpen;
    const isTransparent = isOverlapping && isAtTop && !isOpen;

    if (isMobileLayout === false) return null;

    return (
        <div
            className={concatClassNames([
                styles.mobileNav,
                isHidden ? styles.hidden : "",
                isOpen ? styles.isOpen : "",
                isTransparent
                    ? themeStyles.darkThemeText
                    : themeStyles.offWhite,
                isMobileLayout === null ? styles.layoutUnset : styles.layoutSet,
            ])}
            data-mobile-layout
        >
            <div className={styles.inner}>
                <BurgerButton
                    active={mobileMenuOpen}
                    onPress={() => setMobileMenuOpen(!mobileMenuOpen)}
                    controls="mobile-menu"
                    label={
                        mobileMenuOpen
                            ? t`Close navigation menu`
                            : t`Open navigation menu`
                    }
                />

                <Clickable href="/" className={styles.logo}>
                    <Svg name="sks-logo" className={styles.logoSvg} />
                    <VisuallyHidden>{t`SKS: Home`}</VisuallyHidden>
                </Clickable>

                <div className={styles.actions}>
                    <Clickable
                        className={styles.actionButton}
                        onPress={() =>
                            setActiveSubmenu(
                                activeSubmenu === SEARCH_SUBMENU
                                    ? null
                                    : SEARCH_SUBMENU,
                            )
                        }
                        aria-expanded={activeSubmenu === SEARCH_SUBMENU}
                        aria-controls={SEARCH_SUBMENU}
                    >
                        <Svg
                            name="search"
                            className={styles.actionIcon}
                            visuallyHiddenText={t`Search`}
                        />
                    </Clickable>
                    {favoritesUrl && (
                        <Clickable
                            href={favoritesUrl}
                            className={styles.favoritesActionButton}
                        >
                            <Svg
                                name="heart"
                                className={concatClassNames([
                                    styles.actionIcon,
                                    hasFavorites
                                        ? styles.actionIconFilled
                                        : null,
                                ])}
                                visuallyHiddenText={t`Favorites`}
                            />
                        </Clickable>
                    )}
                </div>
            </div>
            {isMobileLayout && <SearchSubmenu />}
        </div>
    );
};
